import type { OrderByDescriptor } from '../types/common/OrderByDescriptor';
import type { ListingViewModel } from '../types/listings/ListingViewModel';
import type { AdListing } from 'types/adListing';
import { MediaService } from '../services/MediaService';

/** Sort option string as used in UI (newest | priceAsc | priceDesc). */
export type ListingSortOption = 'newest' | 'priceAsc' | 'priceDesc';

/**
 * Map UI sort option to backend OrderBy. Filtering is disabled in list pages; only orderBy is sent.
 */
export function sortOptionToOrderBy(sortOption: ListingSortOption): OrderByDescriptor[] {
  switch (sortOption) {
    case 'priceAsc':
      return [{ field: 'Price', descending: false }];
    case 'priceDesc':
      return [{ field: 'Price', descending: true }];
    case 'newest':
    default:
      return [{ field: 'CreatedAt', descending: true }];
  }
}

/**
 * Map ListingViewModel to AdListing for list/detail UI.
 */
export function listingViewModelToAdListing(lv: ListingViewModel): AdListing {
  const konum = [lv.city?.name, lv.district?.name].filter(Boolean).join(', ') || '';
  const durum = lv.condition?.name === 'Sıfır' ? 'Sıfır' : 'İkinci El';
  const specs = lv.specs ?? {};
  return {
    id: lv.id,
    baslik: lv.title ?? '',
    aciklama: lv.description ?? '',
    fiyat: lv.price,
    kategori: lv.productType?.name ?? '',
    konum,
    tarih: '',
    saticiId: 0,
    saticiAdi: '',
    resimUrl: MediaService.toImageSrc(
      lv.imageUrls?.[0] ?? lv.images?.[0]?.url ?? lv.images?.[0]?.id ?? ''
    ),
    durum,
    province: lv.city?.name ?? undefined,
    district: lv.district?.name ?? undefined,
    islemci: specs['İşlemci'] ?? specs['islemci'],
    ekranKarti: specs['Ekran Kartı'] ?? specs['ekranKarti'],
    ram: specs['RAM'] ?? specs['ram'],
    ssd: specs['SSD'] ?? specs['ssd'],
    hdd: specs['HDD'] ?? specs['hdd'],
    isUserFavorite: lv.isUserFavorite === true,
  };
}
